let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6dCJv")).then(() => parcelRequire('66Wlt'));